export default function styles(theme) {
  return {
    image: {
      width: "100%",
      height: "100%",
      objectFit: "cover",
      borderRadius: 12,
      background: theme.palette.primary.main,
      border: '4px solid rgba(121, 131, 150, 0.15)',
    },
    title: {
      color: theme.palette.text.primary,
    },
    masonryCard:
    {
      display:"block",
      height: "fit-content",
      marginBottom: '20px'
    },
  };
}
